const reais = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
const numero = new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** "R$ 1.234,56" a partir de centavos; `null` vira travessao. */
export function reaisDosCentavos(centavos: number | null): string {
  return centavos === null ? "—" : reais.format(centavos / 100);
}

/** "1.234,56" para preencher um campo com o valor guardado. */
export function textoDosCentavos(centavos: number | null): string {
  return centavos === null ? "" : numero.format(centavos / 100);
}

/**
 * Valor digitado em reais ("500", "1.234,56", "R$ 80,5") em centavos.
 * Vazio vira `null` (sem valor); texto que nao e dinheiro vira `undefined`.
 */
export function centavosDoTexto(texto: string): number | null | undefined {
  const limpo = texto.replace(/R\$|\s/g, "");
  if (limpo === "") return null;
  if (!/^\d{1,3}(\.\d{3})*(,\d{1,2})?$|^\d+(,\d{1,2})?$/.test(limpo)) return undefined;
  const [inteiro = "0", decimal = ""] = limpo.replace(/\./g, "").split(",");
  return Number(inteiro) * 100 + Number(decimal.padEnd(2, "0"));
}
